export enum AlertTypesEnum {
  Confirm = 'confirm',
  Info = 'info',
  ErrorInfo = 'error-info',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Global = 'global',
  PendingTransactionsSuccessfullyVerified = 'pending-transaction-successfully-verified'
}
